import { render, staticRenderFns } from "./BottomSheetSettingsPictures.vue?vue&type=template&id=ded5c7b4&scoped=true&"
import script from "./BottomSheetSettingsPictures.vue?vue&type=script&lang=js&"
export * from "./BottomSheetSettingsPictures.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetSettingsPictures.vue?vue&type=style&index=0&id=ded5c7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5c7b4",
  null
  
)

export default component.exports